module.exports = __webpack_public_path__ + "fonts/Poppins-MediumItalic.1749e4b6.ttf";